// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__17Bgm","comment":"styles_comment__3CGjK"};